export enum AppReducerType {
  STATIC = "static",
  THEMES = "themes",
  LAYOUTS = "layouts",
  AUTHENTICATION = "authentication",
  HOMEPAGE = "homepage",
  PERSONNEL_INFORMATION = "personnelInformation",
  WORK_PERFORMANCE = "workPerformance",
  DECLARE_LEAVE = "declareLeave",
  PERSONNEL_FORM = "personnelForm",
  REGULATIONs = "regulations",
  INTERNAL_CULTURE = "internalCulture",
  NEWS = "news",
  EVENTS = "events",
  RESEARCH_REPORT = "researchReport",
  OPERATION_PROCESS = "operationProcess",
  INFINITIVE_SCROLL = "infinitiveScroll",
  INTERNAL_DOCUMENT = "internalDocument",
  AUTHORIZATION_DOCUMENT = "authorizationDocument",
  NOTIFICATION = "notification",
  RECRUITMENT = "recruitment",
  EVALUATION = "evaluation",
  SALARY = "salary",
  BIRTHDAY = "birthday",
}

export enum ReduxStateType {
  INIT = "init",
  LOADING = "loading",
  LOADED = "loaded",
  ERROR = "error",
  CANCELLED = "cancelled",
  SUCCESS = "success",
  UNAUTHORIZED = "unauthorized",
}

export interface ReduxData<T> {
  data: T;
  status: ReduxStateType;
  error?: Error;
}
